//
import axios from '../axios/index'
// 查询活动
export const applyList = (id) => {
    return axios.get(`/application/apply/${id}`)
}
// 提交
export const step1Submit = (data) => {
    return axios.post('/application/applications', data)
}
// 展商报名详情ID
export const getExhibRegisterInfo = (id) => {
    return axios.get(`/exhib/getExhibRegisterInfo/${id}`)
}

// 公司id
export const getCorId = (param) => {
    return axios.get('/getCorId', {})
}

// 获取信息
export const getMessage = (params) => {
    return axios.get('/application/exhibitorMessage', {params})
}

// 获取会议联系人信息
export const getMeetingContact = (meetingId) => {
    return axios.get(`/meeting/contact/${meetingId}`)
}

// 通过id查询报名信息
export const exhibitorStatus = (id) => {
    return axios.get(`/application/exhibitorStatus/${id}`)
}

// 更新申请确认状态
export const updateConfirmStatus = (data) => {
    return axios.post('/application/updateConfirmStatus', data)
}

// 生成合同
export const generateContract = (data) => {
    return axios.post(`/application/generateContract`, data)
}

// 获取合同
export const getContract = (id) => {
    return axios.get(`/application/getContractInfo/${id}`)
}

// 确认合同
export const confirmContract = (data) => {
    return axios.post(`/application/confirmContract`, data)
}

// 填写会刊信息
export const journalInformation = (data) => {
    return axios.post(`/application/journalInformation`, data)
}
// 填写会刊信息
export const getJournalInformation = (params) => {
    return axios.get(`/application/applyMessages`, {params})
}
// 关联产品id
export const getAssociated = (id) => {
    return axios.get(`/application/getAssociated/${id}`)
}

// 申请活动
export const applyActive = (data) => {
    return axios.post(`/meeting/applyActive`, data)
}

// 生成合同编号（meetingId 用于按会议读取动态编号前缀）
export const generateContractNo = (exhibitId, meetingId) => {
    return axios.get(`/application/generateContractNo?exhibitId=${exhibitId}${meetingId ? `&meetingId=${meetingId}` : ''}`)
}

// 获取活动编号
export const getProductsByCorId = (id) => {
    return axios.get(`/product/getProductsByCorId/${id}`)
}

// 获取活动编号
export const publishAssociated = (data) => {
    return axios.post(`/application/publishAssociated`, data)
}

// 获取活动编号
export const getExhibitorNum = (id) => {
    return axios.get(`/application/getExhibitorNum/${id}`)
}

// 获取活动编号
export const getConference = (id) => {
    return axios.get(`/meeting/getConference/${id}`)
}

// 获取会议展位信息列表
export const getBoothList = (meetingId) => {
    return axios.get(`/meeting/booth/list/${meetingId}`)
}

// 根据类型获取会议展位信息列表
export const getBoothListByType = (meetingId, boothType) => {
    return axios.get(`/meeting/booth/list/${meetingId}/${boothType}`)
}

// 获取推广码列表（用于获取业务员姓名）
export const getQRCodeList = (meetingId) => {
    return axios.get(`/meeting/qrcodesList/${meetingId}`)
}

// 获取展位配套设施配置列表
// [2026-08-28 修复] 后端实际注册在 /facilityConfig（MeetBoothFacilityConfigController），
// 原路径 /meeting/booth/facilityConfig 404，导致 step1 一直走前端硬编码兜底列表
export const getBoothFacilityConfig = (meetingId) => {
    return axios.get(`/facilityConfig/active/${meetingId}`)
}

// 获取展商已选择的展位配套设施
export const getExhibitorFacility = (exhibitorId) => {
    return axios.get(`/meeting/booth/exhibitorFacility/${exhibitorId}`)
}

// 保存展位配套设施租赁信息
export const saveExhibitorFacility = (data) => {
    return axios.post('/meeting/booth/saveExhibitorFacility', data)
}

// 获取捐赠书籍列表
export const getDonationBooks = (exhibitorId) => {
    return axios.get('/application/getDonationBooks', {
        params: { exhibitorId }
    })
}

// 保存捐赠书籍
export const saveDonationBooks = (data) => {
    return axios.post('/application/saveDonationBooks', data)
}

// 获取受捐单位选项
export const getDonationRecipientOptions = (meetingId) => {
    return axios.get(`/application/getDonationRecipientOptions/${meetingId}`)
}

// ===================== 我要赞助（v9d） =====================

// 获取会议赞助挡位（启用）
export const getSponsorTiers = (meetingId) => {
    return axios.get(`/application/getSponsorTiers`, { params: { meetingId } })
}

// 展商已提交的赞助信息（挡位快照+总额）
export const getSponsorInfo = (exhibitorId) => {
    return axios.get(`/application/getSponsorInfo`, { params: { exhibitorId } })
}

// 保存我要赞助（tierIds 空=清空）
export const saveSponsor = (data) => {
    return axios.post('/application/saveSponsor', data)
}

// ===================== 我的产品（v9d，归属企业跨会议） =====================

// 我的产品列表
export const getMyProducts = (corporateId, keyword) => {
    return axios.get(`/application/myProducts`, { params: { corporateId, keyword: keyword || '' } })
}

// 产品详情
export const getMyProductDetail = (id) => {
    return axios.get(`/application/myProducts/${id}`)
}

// 创建产品
export const createMyProduct = (data) => {
    return axios.post('/application/myProducts', data)
}

// 编辑产品
export const updateMyProduct = (id, data) => {
    return axios.put(`/application/myProducts/${id}`, data)
}

// 删除产品（软删）
export const deleteMyProduct = (id) => {
    return axios.delete(`/application/myProducts/${id}`)
}


// ============================================================
// 以下为独立化改造新增接口（手机号登录 / 注册 / 会议选择）
// ============================================================

// 发送短信验证码（后端 @RequestParam，query 参数最稳）
export const sendSms = (phone) => axios.post('/sendSms', null, { params: { phone } })

// 手机号 + 验证码登录
export const loginByPhone = (phone, code) => axios.post('/loginByPhone', null, { params: { phone, code } })

// 获取可报名的会议列表
export const listEnrollableMeetings = () => axios.get('/meeting/listEnrollable')

// 企业认证（首次登录建企业，需 token，后端从 token 解 userId 建关联）
export const corporateRegister = (data) => axios.post('/my/corporateDetails', data)

